import { i18n } from 'i18next'

export const loadLocalTranslations = async (
  i18nInstance: i18n,
  appName: string,
  lang: string
) => {
  try {
    const translations = await import(
      `../../../../apps/${appName}/src/locale/${lang}.json`
    )
    i18nInstance.addResourceBundle(lang, appName, translations.default)
    await i18nInstance?.changeLanguage(lang)
  } catch (error) {
    console.error(`Failed to load translations for ${appName}:`, error)
  }
}
